import { useState } from "react";
import { supabase } from "../../lib/supabase";
import { useAppStore } from "../../store";

export function AccountSettings() {
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const { clearAuth } = useAppStore();

  // Get user email from Supabase session
  const [userEmail, setUserEmail] = useState<string>("");
  supabase?.auth.getSession().then(({ data: { session } }) => {
    if (session?.user.email) setUserEmail(session.user.email);
  });

  const handleExport = () => {
    const apiBase = import.meta.env.VITE_API_BASE ?? "";
    const token = useAppStore.getState().authToken;
    fetch(`${apiBase}/api/account/export`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `stride-export-${new Date().toISOString().split("T")[0]}.json`;
        a.click();
        URL.revokeObjectURL(url);
      });
  };

  const handleDelete = async () => {
    setLoading(true);
    const apiBase = import.meta.env.VITE_API_BASE ?? "";
    const token = useAppStore.getState().authToken;
    await fetch(`${apiBase}/api/account`, {
      method: "DELETE",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    await supabase?.auth.signOut();
    clearAuth();
    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-4">
      <h4 className="text-label text-text-muted">Account</h4>

      {userEmail && (
        <div className="text-body text-text-muted">
          Signed in as <span className="text-text-primary">{userEmail}</span>
        </div>
      )}

      <button
        onClick={handleExport}
        className="w-full flex items-center gap-3 rounded-lg px-3.5 py-3 text-body text-text-primary interactive-ghost text-left"
      >
        Export my data
      </button>

      <div className="mt-2">
        {!deleteConfirm ? (
          <button
            onClick={() => setDeleteConfirm(true)}
            className="text-caption"
            style={{ color: "#f87171" }}
          >
            Delete account...
          </button>
        ) : (
          <div className="flex flex-col gap-2">
            <p className="text-caption" style={{ color: "#f87171" }}>
              This permanently deletes all your data.
            </p>
            <div className="flex gap-2">
              <button
                onClick={handleDelete}
                disabled={loading}
                className="text-micro px-3 py-1.5 rounded"
                style={{ background: "#ef4444", color: "white" }}
              >
                {loading ? "Deleting..." : "Yes, delete everything"}
              </button>
              <button
                onClick={() => setDeleteConfirm(false)}
                className="text-micro px-3 py-1.5 rounded text-text-muted"
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
